"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specifications = [{
  id: 1,
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/8222fdb5-feb0-4b8e-adfa-477f45a8edd9.jpg",
  imgAlt: "Geodesic satellite radome on rooftop platform",
  card1Title1: "Հաճախականությունների տիրույթ",
  card1Value1: "\xA0X band, Ka Band, S Band- TCX",
  card1Title2: "Տրամագիծ",
  card1Value2: "3.9մ",
  card2Title1: "Առանցքներով պտտման միջակայք",
  card2Value1a: "Ազիմուտ ± 180°",
  card2Value1b: "Բարձրություն 0° to 180°",
  card2Value1c: "Խաչաձև Բարձրություն -4° to +4°",
  card2Title2: "Առանցքներով պտտման արագություն",
  card2Value2a: "Ազիմուտ 20°/s",
  card2Value2b: "Բարձրություն 20° /s",
  card2Value2c: "Խաչաձև բարձրություն 1° /s"
}, {
  id: 2,
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/fbcaf96d-aec4-4d83-bb94-fa22b4f7982c.png",
  imgAlt: "Dish Antenna Array",
  card1Title1: "Հաճախականության Տիրույթ",
  card1Value1: "X band RX",
  card1Title2: "Տրամագիծ",
  card1Value2: "2.4մ",
  card2Title1: "Առանցքով պտտման միջակայք",
  card2Value1a: "Ազիմուտ ± 180°",
  card2Value1b: "Բարձրություն 0° to 180°",
  card2Value1c: "",
  card2Title2: "",
  card2Value2a: "",
  card2Value2b: "",
  card2Value2c: ""
}];
export default function AntennaTechnicalSpecifications() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="antennatechnicalspecifications" className="bg-background text-foreground py-16 md:py-24 overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className={`flex flex-col transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {specifications.map((spec, index) => <React.Fragment key={spec.id}>
              <div data-index={index} className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 items-stretch">
                {}
                <div className="col-span-1 rounded-xl overflow-hidden border border-border/40 shadow-lg relative group h-64 lg:h-auto min-h-[250px]">
                  <div className="absolute inset-0 bg-primary/10 mix-blend-overlay z-10 transition-opacity duration-500 group-hover:opacity-0"></div>
                  <img src={spec.imgSrc} data-wvc-srcset={`${spec.imgSrc}-wvc-srcset`} data-wvc-sizes={`${spec.imgSrc}-wvc-sizes`} alt={spec.imgAlt} loading="lazy" className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" />
                </div>

                {}
                <Card className="col-span-1 bg-card/60 backdrop-blur-md border-chart-3/30 shadow-md hover:border-chart-3/60 transition-colors duration-300 h-full">
                  <CardContent className="p-6 md:p-8 flex flex-col h-full justify-center gap-6">
                    {spec.card1Title1 && <div>
                        <h4 className="font-default font-bold text-lg md:text-xl text-foreground mb-2 tracking-wide">
                          {spec.card1Title1}
                        </h4>
                        <p className="font-mono text-sm md:text-base text-muted-foreground">
                          {spec.card1Value1}
                        </p>
                      </div>}
                    {spec.card1Title2 && <div>
                        <h4 className="font-default font-bold text-lg md:text-xl text-foreground mb-2 tracking-wide">
                          {spec.card1Title2}
                        </h4>
                        <p className="font-mono text-sm md:text-base text-muted-foreground">
                          {spec.card1Value2}
                        </p>
                      </div>}
                    {spec.card1Title3 && <div>
                        <h4 className="font-default font-bold text-lg md:text-xl text-foreground mb-2 tracking-wide">
                          {spec.card1Title3}
                        </h4>
                        <p className="font-mono text-sm md:text-base text-muted-foreground">
                          {spec.card1Value3}
                        </p>
                      </div>}
                  </CardContent>
                </Card>

                {}
                <Card className="col-span-1 bg-card/60 backdrop-blur-md border-chart-3/30 shadow-md hover:border-chart-3/60 transition-colors duration-300 h-full">
                  <CardContent className="p-6 md:p-8 flex flex-col h-full justify-center gap-6">
                    {spec.card2Title1 && <div>
                        <h4 className="font-default font-bold text-lg md:text-xl text-foreground mb-3 tracking-wide">
                          {spec.card2Title1}
                        </h4>
                        <ul className="space-y-2">
                          {spec.card2Value1a && <li className="font-mono text-sm md:text-base text-muted-foreground flex items-start">
                              <span className="text-chart-3 mr-2 mt-0.5">▹</span>
                              {spec.card2Value1a}
                            </li>}
                          {spec.card2Value1b && <li className="font-mono text-sm md:text-base text-muted-foreground flex items-start">
                              <span className="text-chart-3 mr-2 mt-0.5">▹</span>
                              {spec.card2Value1b}
                            </li>}
                          {spec.card2Value1c && <li className="font-mono text-sm md:text-base text-muted-foreground flex items-start">
                              <span className="text-chart-3 mr-2 mt-0.5">▹</span>
                              {spec.card2Value1c}
                            </li>}
                        </ul>
                      </div>}

                    {spec.card2Title2 && <div>
                        <h4 className="font-default font-bold text-lg md:text-xl text-foreground mb-3 tracking-wide">
                          {spec.card2Title2}
                        </h4>
                        <ul className="space-y-2">
                          {spec.card2Value2a && <li className="font-mono text-sm md:text-base text-muted-foreground flex items-start">
                              <span className="text-chart-3 mr-2 mt-0.5">▹</span>
                              {spec.card2Value2a}
                            </li>}
                          {spec.card2Value2b && <li className="font-mono text-sm md:text-base text-muted-foreground flex items-start">
                              <span className="text-chart-3 mr-2 mt-0.5">▹</span>
                              {spec.card2Value2b}
                            </li>}
                          {spec.card2Value2c && <li className="font-mono text-sm md:text-base text-muted-foreground flex items-start">
                              <span className="text-chart-3 mr-2 mt-0.5">▹</span>
                              {spec.card2Value2c}
                            </li>}
                        </ul>
                      </div>}
                  </CardContent>
                </Card>
              </div>

              {}
              {index < specifications.length - 1 && <Separator className="my-12 md:my-16 bg-border/30" />}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}